import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { STATUS_APPLICATIONS } from '../../constants/statusApplications';
import '../../styles/modals/statusModal.css';

const StatusModal = ({ isOpen, onClose, status }) => {
  // 모달이 열리면 페이지 스크롤 방지
  useEffect(() => {
    if (isOpen) {
      // 모달이 열리면 배경 스크롤 방지
      document.body.style.overflow = 'hidden';
      
      // 컴포넌트 언마운트 시 원래대로 복원
      return () => {
        document.body.style.overflow = 'auto';
      };
    }
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  const getStatusMessage = () => {
    switch(status) {
      case 'documentPassed':
        return {
          title: 'Congratulations on passing the document screening!',
          message: 'Instructions for the next step will be sent by email. Please check your email.'
        };
      case 'documentFailed':
        return {
          title: 'Unfortunately, you did not pass the document screening.',
          message: 'We encourage you to apply again in the future. Thank you.'
        };
      case 'selected':
        return {
          title: 'Congratulations on being selected for K-Startup Grand Challenge 2025!',
          message: 'Detailed information about program participation will be sent by email.'
        };
      case 'rejected':
        return {
          title: 'Unfortunately, you were not selected for the final round.',
          message: 'We encourage you to apply again in the future. Thank you.'
        };
      default:
        return {
          title: 'Thank you for your application.',
          message: 'Results will be notified via email.'
        };
    }
  };
  
  const statusObj = STATUS_APPLICATIONS.find(s => s.value === status);
  const statusLabel = statusObj ? statusObj.label : 'Status information not available';
  const { title, message } = getStatusMessage();
  
  // 모달 외부 클릭 핸들러
  const handleOverlayClick = (e) => {
    // 모달 내부 클릭은 처리하지 않음
    if (e.target.className === 'status-modal-overlay') {
      onClose();
    }
  };

  return (
    <div className="status-modal-overlay" onClick={handleOverlayClick}>
      <div className="status-modal" data-status={status || 'default'}>
        <div className="status-modal-header">
          <div className="status-badge">{statusLabel}</div>
          <h2>{title}</h2>
        </div>
        <div className="status-modal-content">
          <p>{message}</p>
        </div>
        <div className="status-modal-footer">
          <button onClick={onClose}>Confirm</button>
        </div>
      </div>
    </div>
  );
};

StatusModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  status: PropTypes.string
};

export default StatusModal; 